<template>
    <div>
        <canvas ref="canvas" />
    </div>
</template>

<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        name: 'DoughnutChart',
        extends: Doughnut,
        props: {
            chartData: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 70,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                return `${this.type}: ${value}`
                            }
                        }
                    }
                }
            }
        },
        watch: {
            chartData: {
                handler(newData) {
                    this.renderChart(newData, this.options)
                },
                deep: true
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.options)
        }
    }
</script>
